const YOUTUBE_ID_RE = /^[a-zA-Z0-9_-]{11}$/;

export function getYoutubeVideoId(input) {
  if (!input) return '';
  const raw = String(input).trim();
  if (YOUTUBE_ID_RE.test(raw)) return raw;

  let url;
  try {
    url = new URL(raw.startsWith('http') ? raw : `https://${raw}`);
  } catch {
    return '';
  }

  const host = url.hostname.replace(/^www\./, '');
  const path = url.pathname;

  if (host === 'youtu.be') {
    const id = path.split('/').filter(Boolean)[0] || '';
    return YOUTUBE_ID_RE.test(id) ? id : '';
  }

  const youtubeHosts = ['youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtube-nocookie.com'];
  if (!youtubeHosts.includes(host)) return '';

  const queryId = url.searchParams.get('v');
  if (YOUTUBE_ID_RE.test(queryId)) return queryId;

  const parts = path.split('/').filter(Boolean);
  if (['shorts', 'embed', 'live', 'v'].includes(parts[0]) && YOUTUBE_ID_RE.test(parts[1])) {
    return parts[1];
  }

  return '';
}

export function getYoutubeThumbnail(videoId) {
  return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
}
